<template>
  <div class="flex mt-auto space-x-4">
    <button
      @click="$emit('contact-seller')"
      class="flex-1 bg-green-600 hover:bg-green-700 text-white py-3 px-4 rounded-md font-medium transition-colors shadow-md"
    >
      Kontaktiraj prodavca
    </button>
    <button
      @click="$emit('toggle-follow')"
      class="flex items-center justify-center text-white py-3 px-4 rounded-md font-medium transition-colors shadow-md"
      :class="
        following
          ? 'bg-red-700 hover:bg-red-800 border border-red-600'
          : 'bg-gray-700 hover:bg-gray-600 border border-gray-600 hover:border-red-400'
      "
      :disabled="isLoading"
    >
      <!-- Loading spinner -->
      <div
        v-if="isLoading"
        class="animate-spin h-4 w-4 mr-2 border-t-2 border-b-2 border-red-400 rounded-full"
      ></div>
      <!-- Heart icon -->
      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4 mr-2"
        :class="following ? 'text-red-400' : 'text-red-400'"
        viewBox="0 0 24 24"
        stroke="currentColor"
        :fill="following ? 'currentColor' : 'none'"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
        />
      </svg>
      <span v-if="following">Prati se</span>
      <span v-else>Prati</span>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ProductActions',
  props: {
    following: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['contact-seller', 'toggle-follow'],
});
</script>
